// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from'axios'
import VueI18n from 'vue-i18n';
import $ from 'jquery'
import Swiper, { Autoplay, Pagination, Navigation } from 'swiper'
import 'swiper/swiper-bundle.min.css'

import ElementUI from'element-ui';
import'element-ui/lib/theme-chalk/index.css';
import ElementLocale from 'element-ui/lib/locale'

import en from './i18n/en.json'
import zh from './i18n/zh.json'
import es from './i18n/es.json'

Vue.config.productionTip = false
Vue.prototype.$http = axios
window.$ = $

window.Swiper = Swiper
Swiper.use([Autoplay, Pagination, Navigation])

Vue.use(ElementUI);
Vue.use(VueI18n);

const savedLocale = localStorage.getItem('lang') || 'es'
const i18n = new VueI18n({
  locale: savedLocale, // 设置默认语言
  messages :{
    zh,
    en,
    es
  }
});
// ElementLocale.i18n((key, value) => i18n.t(key, value))
/* eslint-disable */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js